import { ProductType } from '../../../models/ProductType';

export const formatProductType = (productType: ProductType, grammar: 'singular' | 'plural') => {
    switch (grammar) {
        case 'singular':
            return formatProductTypeSingular(productType);
        case 'plural':
            return formatProductTypePlural(productType);
        default:
            return '';
    }
};

export const formatProductTypeSingular = (productType: ProductType) => {
    switch (productType) {
        case ProductType.ENEWS:
            return 'eNews';
        case ProductType.EMAGAZINE:
            return 'eMagazine';
        case ProductType.ECOMIC:
            return 'eComic';
        case ProductType.INTERACTIVE_EBOOK:
            return 'Interactive eBook';
        default:
            return 'other';
    }
};

export const formatProductTypePlural = (productType: ProductType) => {
    switch (productType) {
        case ProductType.ENEWS:
            return 'eNews';
        case ProductType.EMAGAZINE:
            return 'eMagazines';
        case ProductType.ECOMIC:
            return 'eComics';
        case ProductType.INTERACTIVE_EBOOK:
            return 'Interactive eBooks';
        default:
            return 'other';
    }
};
